import { render, staticRenderFns } from "./PxCamposCompraProdutosViewLm.vue?vue&type=template&id=e2064010&"
import script from "./PxCamposCompraProdutosViewLm.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraProdutosViewLm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports